import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';


// TODO rename schools to orgs
export default makeSettingsReducer('schools');
